import React from 'react';
import { Row, Col, Form } from 'react-bootstrap';
import { useFormikContext } from 'formik';
import { useDispatch } from 'react-redux';
import BalanceInputs from '../NestedInputs/BalanceInputs';

export default function PendingRemunerations({ assets, viewOnly }) {
  const dispatch = useDispatch();
  const { values, errors } = useFormikContext();
  return (
    <>
      <Row className="summary__balances_header small">
        <Col md={6} className="">
          <strong>Remuneraciones Pendientes</strong>
        </Col>
        <Col className="col-1 " />
      </Row>
      <Row>
        <Col xl={12} xs={12} md={12} lg={12} style={{ textAlign: 'center' }}>
          <BalanceInputs
            isVariable={false}
            variable="settlement"
            subVariable="pendingRemunerationBalances"
            balanceType="asset"
            dispatch={dispatch}
            assets={assets.fixedAssets}
            extraValueProps={{
              variable: 'not_variable',
              settlement_base: 'pending_remuneration'
            }}
            discounts={[]}
            allValuesAttributes={values?.settlement?.pendingRemunerationBalances || []}
            createOnClick={!viewOnly}
            canCreate={!viewOnly}
            canDestroy={!viewOnly}
          />
        </Col>
        <Col xl={12} xs={12} md={12} lg={12} style={{ marginBottom: 10, textAlign: 'center' }}>
          {typeof errors.settlement?.pendingRemunerationBalances === 'string' && (
            <Form.Text className="text-danger">
              <strong>{errors.settlement.pendingRemunerationBalances}</strong>
            </Form.Text>
          )}
        </Col>
      </Row>
    </>
  );
}
